import type { EntityKey } from '../public-types';


export const OVERREACT_ID_FIELD_NAME = '_OVERREACT_ID';

export function createOverreactId(id: EntityKey, parentId: EntityKey | undefined, parentType: string | null) {
  return `${parentType}:${parentId}:${id}`;
}
